<template>
	<ul class="ux-list">
		<slot/>
	</ul>
</template>
<style lang="scss" scoped>

.ux-list {
	background: var(--bg1, #fff);
	padding:0;
	margin: 0;
	list-style-type: none;
	box-shadow: 0 0.3em 0.5em color-mix(in lab, currentColor 10%, transparent);
	border: 1px solid color-mix(in lab, currentColor 10%, transparent);

	:deep(.ux-list-item) {
		list-style-type: none;
		padding: 0.5em 1em;
		display: block;
		border-bottom: 1px solid color-mix(in lab, currentColor 10%, transparent);



		&:last-child {
			border-bottom:none;
		}
	}
}
</style>